"use strict";
angular.module("hotSpotsTopModule", []).
directive("hotSpotsTop", ['trsHttpService', '$stateParams', "$timeout", function(trsHttpService, $stateParams,$timeout) {
    return {
        replace: true,
        restrict: 'AE',
        scope: {
            boxTitle: "@",
            hotTopList: '=',
            curHotTop: '=',
            callback: '&'
        },
        templateUrl: './planningCenter/hotFocus/directive/hotSpotsTop/hotSpotsTop_tpl.html',
        link: function(scope, $elem, $attrs) {
            initStatus();
            initData();

            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                
            }

            /**
             * [initData description] 初始化数据
             * @return {[type]} [description]
             */
            function initData() {
                
            }

            scope.clickHotSpot = function(item) {
                scope.curHotTop = item;
                $timeout(function() {
                    scope.callback();
                });
            }

        }
    };
}]);